/**
 * Workflow-type predicates shared across the Line Clearance, Production Label,
 * and Equipment Log Book screens.
 *
 * A "WIP-only" line clearance consumes in-house WIP (not warehouse material) and
 * therefore has no dispensing request, no material verification, and only product
 * verification. Compression and Inspection are both WIP-only.
 *
 * Centralising the OR here keeps every gating site consistent and lets a future
 * WIP-only stage be added in one place.
 */

export const isWipOnlyLc = (rec) =>
  rec?.is_compression === true || rec?.is_inspection === true;

export const isWipOnlyLabel = (rec) =>
  rec?.is_compressed === true || rec?.is_inspected === true;
